import * as Yup from 'yup';
import { DictDispatchType } from '@models';

export function useValidationSchema() {
  return Yup.object<DictDispatchType>().shape({
    name: Yup.string().nullable().required(),
    code: Yup.string().nullable().required(),
  });
}
